import {FC} from 'react'

import {IconSize} from '@/theme/icons'
import {theme} from '@/theme/theme'

import {Icon, IconProps} from './Icon'

export const LockIcon: FC<React.PropsWithChildren<IconProps>> = ({
  color = theme.palette.text.primary,
  size = IconSize.large,
}) => (
  <>
    <Icon size={size}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <rect x="3" y="8.5" width="14" height="9" rx="1.75"></rect>
        <path d="M6 8.5V6a4 4 0 0 1 8 0v2.5"></path>
        <circle cx="10" cy="13" r="0.9"></circle>
      </svg>
    </Icon>
  </>
)
